import { render, staticRenderFns } from "./business-config.vue?vue&type=template&id=025ad364&scoped=true&"
import script from "./business-config.vue?vue&type=script&lang=js&"
export * from "./business-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025ad364",
  null
  
)

export default component.exports